/* eslint-disable prefer-template */
/* eslint-disable prettier/prettier */
import React from 'react';

import { FLink } from '@components';
import { useSelector } from 'react-redux';
import { mdiCardAccountDetailsOutline } from '@mdi/js';
import Icons from '../../Icon';
import { MEUS_DADOS } from '../../../utils/paths';
import { multipleFormatString } from '../../../utils/formatString';

export const DadosPessoaisCard = () => {
  const users = useSelector((state) => state.user);
  const {
    celular,
    telefone,
    email,
    cidade,
    bairro,
    complemento,
    numero,
    logradouro,
  } = users.dadosPessoais;
  const custom = useSelector((state) => state.customizaSistema);

  const CELULAR_TELEFONE =
    celular + (celular && telefone && ` | `) + telefone || 'Não informado';

  const EMAIL = email.toLowerCase() || 'Não informado';

  const ENDERECO_COMPLETO = `
    ${logradouro ? multipleFormatString(`${logradouro} ${numero}`) : 'Não informado'}
    ${complemento ? multipleFormatString(` - ${complemento}`) : ''}
    ${bairro ? multipleFormatString(`, ${bairro} - ${cidade}`) : ''}
  `;

  return (
    <div className="card">
      <div className="card-body">
        <Icons
          path={mdiCardAccountDetailsOutline}
          color={custom.codCorLaranja}
          size={2}
          style={{ marginBottom: 10 }}
        />

        <h1 className="ts-20 fw-bold mb-2">Seus dados estão corretos?</h1>
        <p className="ts-14 text-muted mb-md-4">
          Verifique se seus dados de contato e endereço estão atualizados.
        </p>

        <p className="fw-bold text-orange ts-16">Email</p>
        <p className="fw-bold text-muted ts-16">{EMAIL}</p>

        <p className="fw-bold text-orange ts-16 mt-3">Celular</p>
        <p className="fw-bold text-muted ts-16">{CELULAR_TELEFONE}</p>

        <p className="fw-bold text-orange ts-16 mt-3">Endereço</p>
        <p className="fw-bold text-muted ts-16">{ENDERECO_COMPLETO}</p>
      </div>
      <div className="card-footer">
        <hr />
        <FLink className="mt-4" to={MEUS_DADOS} icon>
          Acessar meus dados
        </FLink>
      </div>
    </div>
  );
};
